<template>
  <payment-gateways />
</template>

<script>
import PaymentGateways from '../pro/modules/payment.vue';

export default {
  name: 'PaymentSettings',
  components: { PaymentGateways },
};
</script>
